import React, { useEffect, useRef, useState } from 'react';
// import DeleteModal from '../Calendar/DeleteModal';
// import ArchiveModal from "../Calendar/DeleteModal";
// import { franchisee } from 'src/models/pages/franchiseeModel';
import { Columns, LazyTableState } from 'src/models/components/dataTableWrapperModel';
import { DataTable, DataTableFilterMeta } from 'primereact/datatable';
import { Form, Formik } from 'formik';
import { Button, Col, Row, UncontrolledTooltip } from 'reactstrap';
import Select from 'src/components/Common/Select';
import DataTableWrapper from 'src/components/Grid/DataTableWrapper';
import { ROUTER } from 'src/constants/routes';
import { useNavigate } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { RootReducerState } from 'src/store/reducers';
import { useToast } from 'src/components/Common/ReactToaster';
import CustomizeTable from 'src/components/Common/CustomizeTable/CustomizeTable';
import { Dropdown } from 'primereact/dropdown';
import FeatherIcon from "feather-icons-react";
import { AnimatePresence, motion } from "framer-motion";
import { BUTTON_VARIANT } from 'src/constants/bulkActionVariant';
import EmailBodyTemplate from 'src/components/Common/EmailBodyTemplate/EmailBodyTemplate';
import ExportFile from 'src/components/Common/ExcelPdf Export/ExportFile';
import { formatDateTimeFormServerView, formatDateTimeMEL, saveAsExcelFile } from 'src/helpers/common_helpers';
import FilterIcon from 'src/components/Common/CustomFilterandSortIcon/FilterIcon';
import SortIcon from 'src/components/Common/CustomFilterandSortIcon/SortIcon';
import BulkActionStatus from 'src/components/Common/BulkActionStatus/BulkActionStatus';
import TooltipMEL from 'src/components/UI/Tooltip';
import ValidationPopup from 'src/components/Common/ValidationMessage/ValidationPopup';
import DeleteModal from 'src/pages/Calendar/DeleteModal';
import ArchiveModal from 'src/pages/Calendar/DeleteModal';
import { clearBulkEmailMessage, deleteBulkEmail, getBulkEmailList, getBulkEmailStatus } from 'src/store/BulkEmail/action';
import { API } from 'src/util/api';
import { customizeTableColumns } from 'src/models/components/CustomizeTableColumns';
import { clearNotificationMessage, getNotificationList, getNotificationStatus } from 'src/store/notification/action';
import { Link } from 'react-router-dom';
import ColumnActionMarketing from '../Columnaction/ColumnAction';

const NotificationList: React.FC = () => {
  const filterDetails: DataTableFilterMeta = {
    Status: { value: "", matchMode: "contains" },
    jobNumber: { value: "", matchMode: "contains" },
  };

  let initialLazyState: LazyTableState = {
    first: 0,
    rows: 10,
    page: 1,
    sortField: "CreationTime",
    sortOrder: -1,
    filters: filterDetails,
  };

  const hidePopup = () => { 
    setVisible(false); 
    dispatch(clearNotificationMessage());
  }

  const dialogContainer = (error: any) => {
    return (
      <>
         <ValidationPopup error={error} visible={visible} onHide={hidePopup} />
      </>
    );
  };

  const headerTemplate =(val:any)=>{
    return(
      <div className="d-flex justify-content-start">
        <div className="d-flex justify-content-end"style={{width:"100px"}}  >
        <div className="align-right">
          {val}
        </div>
        </div>
      </div>
    )
    }

  const jobBodyTemplate =(job:any)=>{
    if(job.jobId){
        return(
          <Link to={ROUTER.JOB_SHEETS_VIEW + "/" + job.jobId}>{job.jobNumber}</Link>
        )
    }else{
        return job.jobNumber
    }
    }

  const columns: Columns[] = [
    {
      field: "title",
      sortable: true,
      header: "Title",
      filter: false,
      showFilterMenu: true,
      frozen : true,
      headerStyle: { whiteSpace: "nowrap", width: "600px" },
      body: (rowData) => actionBodyTemplate(rowData, "title"),
      isDefault: true,
      isStatic: true,
    },
    // {
    //   field: "subject",
    //   sortable: true,
    //   header: "Subject",
    //   filter: false,
    //   showFilterMenu: true,
    //   headerStyle: { whiteSpace: "nowrap", minWidth: "300px" },
    //   isDefault: true,
    //   isStatic: false,
    // },
    {
      field: "jobNumber",
      sortable: true,
      header: "Job Number / SR Number",
      filter: true,
      showFilterMenu: true,
      // headerStyle: { whiteSpace: "nowrap" },
      body:(rowData:any)=>jobBodyTemplate(rowData),
      isDefault: true,
      isStatic: false,
    },
    {
      field: "creationTime",
      sortable: true,
      header: "Created At",
      filter: false,
      showFilterMenu: true,
      // headerStyle: { whiteSpace: "nowrap" },
      body:(rowData:any)=>formatDateTimeFormServerView(rowData.creationTime),
      isDefault: true,
      isStatic: false,
    },

    {
      field: "status",
      sortable: false,
      header: "Status",
      filter: false,
      showFilterMenu: false,
      // headerStyle: { whiteSpace: "nowrap" },
      isDefault: true,
      isStatic: false,
    },
  ];

  const [deleteModal, setDeleteModal] = useState(false);
  const [archiveModal, setArchiveModal] = useState(false);
  const [selectAll, setSelectAll] = useState(false);
  const [tooltipOpen, setTooltipOpen] = useState(false);
  const [selectedEmailList, setSelectedEmailList] = useState<any>([]);
  const [rowData, setRowData] = useState<any | null>(null);
  const [lazyState, setLazyState] = useState(initialLazyState);
  const [showCustomizeTable, setShowCustomizeTable] = useState(false);
  const [isTooltipVisible, setIsTooltipVisible] = useState<boolean>(false);
  const [filter, setFilter] = useState(false);
  const [selectedStatus, setselectedStatus] = useState<any>("ALL");
  const [franchiseeData, setFranchiseeData] = useState<any>([]);
  const toggleTooltip = () => setTooltipOpen(!tooltipOpen);
  const [visibleColumns, setVisibleColumns] = useState(columns.filter((eachColumn: Columns) => eachColumn.isDefault));
  const initialValues = {
    status: "",
  };
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { showToast } = useToast();
  const dt = useRef<DataTable<any>>(null);
  const { notificationList, totalRecords ,error, message , loading,paginatorCount,statusList } = useSelector((state: RootReducerState) => state.NotificationReducer);
  const[pdfLoading,setPdfLoading]=useState<boolean>(false)

  useEffect(() => {
    const preloader: any = document.getElementById("preloader");
    if (loading||pdfLoading) {
      preloader.style.display = "block";
    } else {
      preloader.style.display = "none";
    }
  }, [loading,pdfLoading]);



  const actionBodyTemplate = (rowData: any, field: string) => {
    
    return (
      <>
{(rowData.status=="Cancelled"||rowData.status=="Completed") ?
      <ColumnActionMarketing
        displayData={rowData[field] as string}
        isView={true}
        onViewClick={() => viewHandler(rowData)}
      />
    :
      <ColumnActionMarketing
                displayData={rowData[field] as string}
                isPause={false}
                isView={true}
                onViewClick={() => viewHandler(rowData)}
              />

}

      </>

    );
  };

  // const options: Option[] = [
  //   { label: "Active", value: "Active" },
  //   { label: "Deleted", value: "Deleted" }
  // ]
  const status=[{status:"ALL",id:"ALL"},{status:"COMPLETED",id:"COMPLETED"},{status:"PENDING",id:"PENDING"},]
  const options:any = status?.map((item:any)=>({
label:item.status,
value:item.id
  }))
  
  // const handleDeleteUsers = (rowData: franchisee) => {
//   const handleDeleteUsers = (rowData: any, length: number = 0, index: number = 0) => {
  
//     dispatch(deleteBulkEmail(rowData["id"]));
//     setDeleteModal(false);
//     setRowData(null);
//     if (index + 1 === length || index === length) {
//       setTimeout(() => {
//         // dispatch(getBulkEmailList(lazyState));
//       }, 500);
//       setSelectAll(false);
//       setSelectedEmailList([]);
//     }

//   };

  const archiveHandler = () => {
    setSelectAll(false);
    setSelectedEmailList([]);
    setArchiveModal(false);
  };

  const onFilterClickHandler = () => {
    setFilter((preState) => !preState);
  };

  const handleSubmit = (formValue: any) => {
    setselectedStatus(formValue);
    if(formValue=="ALL"){
      setLazyState((state) => ({
        ...state,
        filters: {
          ...state.filters,
          Status: { value: "", matchMode: "contains" },
        },
      }));
    }else{
      setLazyState((state) => ({
        ...state,
        filters: {
          ...state.filters,
          Status: { value: String(formValue), matchMode: "contains" },
        },
      }));
    }

    setVisibleColumns(visibleColumns)
    setIsTooltipVisible(false)
  };

  const handleReset = (formValue: any) => {
    setLazyState((state) => ({
      ...state,
      filters: {
        ...state.filters,
        status: {
          ...state.filters.status,
          value: "",
        }
      },
    }));
  };

  // const viewHandler = (rowData: franchisee) => {
  const viewHandler = (rowData: any) => {
    navigate(`${ROUTER.VIEW_NOTIFICATION}/${rowData["id"]}`);
  };


  // const deleteHandler = (rowData: franchisee) => {
  const deleteHandler = (rowData: any) => {
    
    setDeleteModal(true);
    setRowData(rowData);
  };


  const onSelectionChange = (event: any) => {
    const value = event.value;
    let status=["Completed","Cancelled"]
    let filtered = event.value.filter((item:any)=>!status.includes(item.status))
    setSelectedEmailList(filtered);
    setSelectAll(filtered.length === totalRecords);
    setSelectAll(filtered.length === paginatorCount);
  };
  const onSelectAllChange = (event: any) => {
    const selectAll = event.checked;
    if (selectAll) {
      
      let status=["Completed","Cancelled"]
      let filtered = notificationList.filter((item:any)=>!status.includes(item.status))
      setSelectAll(filtered.length === totalRecords);
      setSelectAll(filtered.length === paginatorCount)
      setSelectedEmailList(filtered);
    } else {
      setSelectAll(false);
      setSelectedEmailList([]);
    }
  };

  const customizeTableColumns: customizeTableColumns[] = columns.map((eachColumns: Columns) => {
    let data: any = {};
    data['field'] = eachColumns.field;
    data['value'] = visibleColumns.some((sCol: any) => sCol.field === eachColumns.field);
    data['isDisable'] = eachColumns.isStatic;
    data['header'] = eachColumns.header;
    return data;
  }).filter((eachColumns: customizeTableColumns) => eachColumns.field != 'select');

  const onSort = (event: any) => {
    setSelectAll(false);
    setSelectedEmailList([]);
    setLazyState(event);
  };
  const onFilter = (event: any) => {
    event["first"] = 0;
    setLazyState(event);
  };

  const [visible, setVisible] = useState(false);
  useEffect(() => {

    if (error) {
      setVisible(true);
      // showToast(error, { type: "error" })
    }
    if (message) {
      showToast(message, { type: "success" });
      dispatch(clearNotificationMessage());
      dispatch(getNotificationList(lazyState));
    }
  }, [error, message]);

  const onPage = (event: any) => {
    setLazyState(event);
  };
  const onCreateClickHandler = () => {
    navigate(ROUTER.BULK_EMAIL_SENDER);
  };

  const callbackFunction = (lazyState: LazyTableState) => {
    dispatch(getNotificationList(lazyState));
  };

  const customizeTableClickHandler = () => {
    setShowCustomizeTable(true);
  };

  const customizeTableCancelHandler = () => {
    setShowCustomizeTable(false);
  };

  const customizeColumnSubmitHandler = (customizeColumnObject: any[]) => {
    let orderedSelectedColumns = columns.filter((col) => customizeColumnObject.some((sCol: any) => sCol === col.field));

    setVisibleColumns([ ...orderedSelectedColumns]);
    setShowCustomizeTable(false);
  };

  const bulkActionClickHandler = () => {
    if (notificationList.length > 0) {
      let status=["Completed","Cancelled"]
      let filtered = notificationList.filter((item:any)=>!status.includes(item.status))
      setSelectAll(filtered.length === totalRecords);
      setSelectAll(filtered.length === paginatorCount)
      setSelectedEmailList(filtered);
    }
  };

  const cancelBulkActionHadler = () => {
    setSelectAll(false);
    setSelectedEmailList([]);
  };

  useEffect(() => {
    setSelectAll(false);
    setSelectedEmailList([]);
    callbackFunction(lazyState);
  }, [lazyState]);

  const fetchData = async (isPdf:boolean) => {
    let lazy:any= {
      ...lazyState,
      rows:totalRecords>5000 ? 5000 : totalRecords<1 ? 1 : totalRecords,
      first:0,
      filters: {
        ...lazyState.filters,
      },
    };
    
    try {
      setPdfLoading(true)
      const response = await API.getNotificationListAPI(lazy);
      if (!response) {
        throw new Error('Network response was not ok');
      }
     if(isPdf){

       saveDataAsPdf(response?.data?.items, columns, "Notification");
     }else{
      saveDataAsExcel(response?.data?.items, "Notification");
     }
     setPdfLoading(false)
    } catch (error:any) {
      showToast(error.message,{type:"error"})
      setPdfLoading(false)
      
    } finally {
      setPdfLoading(false)
    }
  };

  const csvClickHandler = () => {
    fetchData(false)
  };

  const pdfClickHandler = () => {
    fetchData(true)
  };
  const clearFilter=()=>{
    setLazyState(initialLazyState)
    setselectedStatus("ALL")
  }


  const header =
    <div className="table-header-container">
      <div>
        Notification List
      </div>
      <div className="table-header-container-item table-header-container-item-special">

      </div>
      <div className="flex-grow-1"></div>
      <div className="table-header-container-item">
      <div style={{ display: "flex" }}>
        <ExportFile exportExcel={csvClickHandler} exportPdf={pdfClickHandler} clearFilter={clearFilter} isFilter={false}/>
        <TooltipMEL title="Select Status" position="bottom" tooltipVisible={isTooltipVisible} setTooltipVisible={setIsTooltipVisible}>
       <Dropdown value={selectedStatus} onChange={(e) => handleSubmit(e.value)} options={options} optionLabel="label" placeholder="Select status .."
            filter className="w-full md:w-14rem" /> 
        </TooltipMEL>
        <Button type="button" className="customize-table-button" id="ScheduleUpdateTooltip"
          onMouseEnter={() => setTooltipOpen(true)}
          onMouseLeave={() => setTooltipOpen(false)} data-btn="btn" onClick={customizeTableClickHandler}>
          <FeatherIcon icon="sliders" className="" />
        </Button>
        </div>
        <UncontrolledTooltip
          placement="bottom"
          target="ScheduleUpdateTooltip"
          isOpen={tooltipOpen}
          toggle={toggleTooltip}
          innerClassName="tooltip-color"
        >
          Choose fields you want to see in the table
        </UncontrolledTooltip>
      </div>

    </div>;

  const changeColumnDetails = (values: any[]) => {
    let modifiedColumnDetails = values.map((a) => {
      let data: any = {};
      data['Title'] = a.title;
      data['Subject'] = a.subject;
      data['Created At'] = formatDateTimeFormServerView(a.creationTime);
      data['Job Number'] = a.jobNumber;
      data['Status']=a.status
      return data ;
    });
    return modifiedColumnDetails;
  };

  const saveDataAsExcel = async (values: any[], fileName: string) => {
    let modifiedColumnDetails = await changeColumnDetails(values);
    import('xlsx').then((xlsx) => {
      const worksheet = xlsx.utils.json_to_sheet(modifiedColumnDetails);
      const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
      const excelBuffer = xlsx.write(workbook, {
        bookType: 'xlsx',
        type: 'array'
      });
      saveAsExcelFile(excelBuffer, fileName);
    });
  };

  const saveDataAsPdf = (values: any[], columns: any[], fileName: string) => {
    const destructureedData = values.map((a) => {
      let datas = {
        title: a.title,
        subject: a.subject,
        jobNumber: a.jobNumber,
        creationTime: formatDateTimeFormServerView(a.creationTime),
        status:a.status
      };
      return datas;
    });
    import("jspdf").then((jsPDF) => {
      import("jspdf-autotable").then(() => {
        const exportColumns = columns.map((col) => ({
          title: col.header,
          dataKey: col.field,
        }));
        const doc = new (jsPDF as any).default(0, 0);
        doc.autoTable(exportColumns, destructureedData);
        doc.save(`${fileName}.pdf`);
      });
    });
  };
useEffect(()=>{
  dispatch(getNotificationStatus())
},[])
  return (
    <React.Fragment>
      <div className="page-content">
        {visible && dialogContainer(error)}
        <ArchiveModal
          show={archiveModal}
          message="you want to archieve these administrators?"
          deleteLabel="Yes"
          closeLabel="No"
          onDeleteClick={() => {
            archiveHandler();
          }}
          onCloseClick={() => {
            setArchiveModal(false);
            setSelectAll(false);
            setSelectedEmailList([]);
          }}
        />

        {showCustomizeTable && <CustomizeTable onCancelHandler={customizeTableCancelHandler} onCustomizeColumnSubmitHandler={customizeColumnSubmitHandler} columns={customizeTableColumns} />}


        {filter && (
          <div className="card">
            <div className="card-body">
              <Formik
                initialValues={initialValues}
                onSubmit={handleSubmit}
                onReset={handleReset}
                enableReinitialize
              >
                {({ values, handleChange }) => {
                  return (
                    <Form onChange={handleChange}>
                      <Row>
                        <Col xs={12} lg={7} id="export-search-clear">

                        </Col>
                        <Col xs={12} lg={5} id="export-search-clear d-flex">
                          <Select
                            label=""
                            name="status"
                            value={values.status}
                            onChange={handleChange}
                            options={options}
                            invalid={false}
                          />
                          <Button className="btn btn-primary ms-2" color="primary" type="reset">
                            Clear </Button>
                          <Button className="btn btn-primary ms-2" color="primary" type="submit">
                            Search </Button>
                        </Col>
                      </Row>
                    </Form>
                  );
                }}
              </Formik>
            </div>
          </div>
        )}
        <DataTableWrapper
          ref={dt}
          columnDetails={(selectedStatus=="ALL"||selectedStatus==2||selectedStatus==3)? [...visibleColumns]?.filter((items:any)=>items.field!="select") : visibleColumns}
          header={header}
          filterIcon={FilterIcon}
          sortIcon={(setOrder) => <SortIcon order={setOrder} />}
          value={notificationList}
          lazy
          paginator={true}
          stripedRows={true}
          rowHover={true}
          // filterDisplay="row"
          rowsPerPageOptions={[5, 10, 25, 50]}
          totalRecords={totalRecords}
          // loading={loading}
          emptyMessage="No details found."
          paginatorTemplate="CurrentPageReport FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown"
          currentPageReportTemplate="Displaying Notification  {last} records of {totalRecords} in total"
          selection={selectedEmailList}
          onSelectionChange={onSelectionChange}
          selectAll={selectAll}
          onSelectAllChange={onSelectAllChange}
          first={lazyState.first}
          onSort={onSort}
          sortField={lazyState.sortField}
          sortOrder={lazyState.sortOrder}
          onFilter={onFilter}
          filters={lazyState.filters}
          onPage={onPage}
          rows={lazyState.rows}
        ></DataTableWrapper>
      </div>
    </React.Fragment>
  );
};

export default NotificationList;